module.exports = __webpack_public_path__ + "img/msp-logo.6f2d4f74.png";